module.exports = __webpack_public_path__ + "media/images/pt-BR-87a5bcd4.svg";